import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 5h-5.2L15 3H9L7.2 5H2v16h20V5zm-2 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
}), 'MonochromePhotosSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MonochromePhotosSharp.js
// module id = 4894
// module chunks = 2